import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { initI18n } from './shared/i18n/config';
import { useAuth } from './shared/hooks/useAuth';
import './styles/index.css';

async function bootstrap(): Promise<void> {
  await initI18n();

  // Hydrate auth state from sessionStorage (fire-and-forget).
  void useAuth.getState().bootstrap();

  document.documentElement.setAttribute('data-brand', 'petota-business');

  // Honor stored theme preference (default: light).
  const storedTheme = window.localStorage.getItem('petota-business:theme');
  if (storedTheme === 'dark') {
    document.documentElement.classList.add('dark');
  }

  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('#root mount node is missing');

  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );
}

void bootstrap();
